import { ArrowDownTrayIcon } from '@heroicons/react/24/outline'
import { useState } from 'react'
import { useParams } from 'react-router-dom'
import { signContractorApplication, signContractorConsentForm } from 'services/apis'
import { Button, Modal, Toggle } from 'stories/components'

type ContractorSignDialogProps = {
  onSign: (data: any) => void
  onClose: () => void
  applicationPDF: () => void
  signType?: 'application' | 'consent'
  title?: string
  titleOkay?: string
  reviewedLabel?: string
  successHint?: string
}

export const ContractorSignDialog = ({
  onSign,
  onClose,
  applicationPDF,
  signType = 'application',
  title = 'Confirm and Sign Application',
  titleOkay = 'Confirm and Sign',
  reviewedLabel = 'I have reviewed my application',
  successHint = 'Upon successful signing of this PDF, you will be redirected to the documents upload page.',
}: ContractorSignDialogProps) => {
  const { no } = useParams() as any
  const [isReviewed, setReviewed] = useState(false)
  const [isLoading, setLoading] = useState(false)

  const onDownloadPdf = () => {
    applicationPDF()
  }

  const onConfirmSign = async () => {
    setLoading(true)
    const res =
      signType === 'consent' ? await signContractorConsentForm(no) : await signContractorApplication(no)
    setLoading(false)
    if (res.success) {
      onClose()
      onSign(res.data)
    }
  }

  return (
    <Modal
      isOpen
      title={title}
      titleOkay={titleOkay}
      disabled={!isReviewed}
      loading={isLoading}
      onClose={onClose}
      onOk={onConfirmSign}
    >
      <div className={`text-gray-600 mb-4 text-md overflow-hidden`}>
        <p className="font-bold">
          {signType === 'consent'
            ? 'Once your consent form is signed, you will not be able to edit it'
            : 'Once your application is signed, you will not have the functionality to edit the application'}
        </p>
        <div className="text-sm bg-gray-100 px-2 pb-4 rounded gap-4">
          <div className="ml-1">
            <Button link onClick={onDownloadPdf}>
              <div className="flex items-center underline text-gray-900 hover:text-shade-blue">
                - View Unsigned {signType === 'consent' ? 'Consent Form' : 'Loan Disclosures'} in PDF{' '}
                <span className="ml-2">
                  <ArrowDownTrayIcon className="w-4 h-4" />
                </span>
              </div>
            </Button>
            <Toggle
              id="reviewed"
              title={reviewedLabel}
              onChange={(value) => setReviewed(value)}
              value={isReviewed}
            />
          </div>
          <div
            className="bg-blue-100 border border-blue-400 text-blue-700 px-4 py-3 rounded relative mt-4 text-[14px]"
            role="alert"
          >
            {successHint}
          </div>
        </div>
      </div>
    </Modal>
  )
}
